<div class="tab-pane show active text-center  promos py-4" id="nav-promo" role="tabpanel" style="padding: 200px 0">
  <router-outlet></router-outlet>
</div>
